"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _TopNavStyled = require("./TopNav-styled");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var TopNavBrand = function TopNavBrand(_ref) {
  var children = _ref.children,
      src = _ref.src,
      alt = _ref.alt,
      imageStyle = _ref.imageStyle,
      other = _objectWithoutProperties(_ref, ["children", "src", "alt", "imageStyle"]);

  return _react.default.createElement(_TopNavStyled.StyledTopNavBrandLink, other, _react.default.createElement(_TopNavStyled.StyledTopNavBrandImg, {
    src: src,
    alt: alt,
    style: imageStyle
  }));
};

TopNavBrand.propTypes = {
  /** The HTML src property of the brand image. */
  src: _propTypes.default.node,

  /** The HTML alt property of the brand image. */
  alt: _propTypes.default.node,

  /** Style property for the underlying img element. */
  imageStyle: _propTypes.default.object
};
TopNavBrand.defaultProps = {
  alt: 'Logo'
};
TopNavBrand.displayName = 'TopNavBrand';
var _default = TopNavBrand;
exports.default = _default;